import ArtistIndex from '../components/Artist/Index'
import ArtistCreate from '../components/Artist/Create'
import ArtistDetail from '../components/Artist/Detail'

export default [
  {
    path: '/client/artists/',
    name: 'artist-index',
    component: ArtistIndex,
    meta: {
      sideMenuId: 'my-artist',
    },
  },
  {
    path: '/client/artists/new',
    name: 'artist-new',
    props: {
      isNew: true,
    },
    component: ArtistCreate,
    meta: {
      sideMenuId: 'artist-create',
    },
  },
  {
    path: '/client/artists/create',
    name: 'artist-create',
    props: {
      type: 'artist',
    },
    component: ArtistCreate,
    meta: {
      sideMenuId: 'artist-create',
    },
  },
  {
    path: '/client/artists/create-from-release',
    name: 'artist-create-from-release',
    props: {
      type: 'release',
    },
    component: ArtistCreate,
    meta: {
      sideMenuId: 'artist-create',
    },
  },
  {
    path: '/client/artists/:id',
    name: 'artist-detail',
    component: ArtistDetail,
    props: true,
    meta: {
      sideMenuId: 'my-artist',
    },
  },
  {
    path: '/client/artists/edit/:id',
    name: 'artist-edit',
    props: {
      type: 'artist',
      isNew: false,
      isEdit: true,
    },
    component: ArtistCreate,
    meta: {
      sideMenuId: 'artist-create',
    },
  },
]
